var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentosFirmadosCursor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pictograma_-_Documentos_Firmados",
    "data-name": "Pictograma - Documentos Firmados",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30.04,
    height: 34.33,
    viewBox: "0 0 30.04 34.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-2 {\r\n        clip-path: url(#clip-path);\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: #316094;\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1727",
    "data-name": "Rect\\xE1ngulo 1727",
    className: "cls-1",
    width: 30.04,
    height: 34.33
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2497",
    "data-name": "Grupo 2497",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4474",
    "data-name": "Trazado 4474",
    className: "cls-3",
    d: "M21.07,4.29a6.031,6.031,0,0,0-1.28-2.15,4.351,4.351,0,0,0-.48-.48A6.292,6.292,0,0,0,17.17.38,6.116,6.116,0,0,0,15.02,0h-.01a6.274,6.274,0,0,0-2.13.37,6.155,6.155,0,0,0-2.15,1.27,3.936,3.936,0,0,0-.5.5A6.031,6.031,0,0,0,8.95,4.29H0V34.33H30.04V4.29Zm-6.17,0a.375.375,0,0,1,.11-.01h.01a.34.34,0,0,1,.1.01,1.6,1.6,0,0,1,1.49,1.59,1.471,1.471,0,0,1-.11.56,1.58,1.58,0,0,1-1.48,1.05h-.01a1.6,1.6,0,0,1-1.5-1.05,1.471,1.471,0,0,1-.11-.56,1.6,1.6,0,0,1,1.5-1.59M13.95,23.6l-.65.66-1.47,1.47-1.1-1.1-.37-.37L9.7,23.6,6.44,20.34l1.03-1.03.44-.44.67.67,1.91,1.92.24.24,1.1,1.1,1.05-1.05.29-.29,1.85-1.85.3-.3,1.85-1.85.29-.29,1.85-1.85.3-.3,1.85-1.85.66-.66.36.36,1.1,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4475",
    "data-name": "Trazado 4475",
    className: "cls-4",
    d: "M23.58,13.97,13.95,23.6l-.65.66-1.47,1.47-1.1-1.1-.37-.37L9.7,23.6,6.44,20.34l1.03-1.03.44-.44.67.67,1.91,1.92.24.24,1.1,1.1,1.05-1.05.29-.29,1.85-1.85.3-.3,1.85-1.85.29-.29,1.85-1.85.3-.3,1.85-1.85.66-.66.36.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4476",
    "data-name": "Trazado 4476",
    className: "cls-4",
    d: "M16.61,5.88a1.471,1.471,0,0,1-.11.56,1.58,1.58,0,0,1-1.48,1.05h-.01a1.6,1.6,0,0,1-1.5-1.05,1.471,1.471,0,0,1-.11-.56,1.6,1.6,0,0,1,1.5-1.59.375.375,0,0,1,.11-.01h.01a.34.34,0,0,1,.1.01,1.6,1.6,0,0,1,1.49,1.59"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentosFirmadosCursor);
export default __webpack_public_path__ + "static/media/documentosFirmadosCursor.61639ae155b2bff4f7fa23cb61096e23.svg";
export { ForwardRef as ReactComponent };